module.exports = __webpack_public_path__ + "static/media/2a.c0a2075d.jpg";